import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { CenterRoleStore } from '../../stores/center/role.store';

export const RoleGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
) => {
  const roleStore = inject(CenterRoleStore);
  const router = inject(Router);
  const myRole = roleStore.myRole();

  if (!myRole) {
    return true;
  }

  // route data 에서 requiredRoles 를 가져옵니다.
  const roles: string[] = route.data['requiredRoles'] || [];

  // 현재 접속한 사용자의 권한이 requiredRoles 에 포함되어 있는지 확인합니다.
  roles.map((role) => {
    if (!myRole?.permissions.includes(role)) {
      router.navigate(['/no-role']);
      return false;
    }

    return true;
  });

  return true;
};
